import script from "./bancai.vue?vue&type=script&setup=true&lang=js"
export * from "./bancai.vue?vue&type=script&setup=true&lang=js"

import "./bancai.vue?vue&type=style&index=0&id=a9e28574&scoped=true&lang=css"
import "./bancai.vue?vue&type=style&index=1&id=a9e28574&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e28574"]])

export default __exports__